import {
  ToggleGroup,
  ToggleGroupItem,
} from 'designSystem/components/ToggleGroup'
import type { ViewMode } from 'features/knowledgeDocumentViewer/types'
import React from 'react'

export const VIEW_MODE_TOGGLE_KEY_CAPTURE_SELECTOR =
  '[data-view-mode-toggle-no-keys]'

export interface DocumentViewModeToggleProps {
  viewMode: ViewMode
  onViewModeChange: (value: string | number) => void
}

export function DocumentViewModeToggle({
  viewMode,
  onViewModeChange,
}: DocumentViewModeToggleProps): React.ReactElement {
  const handleValueChange = (nextViewMode: string): void => {
    if (nextViewMode === 'card' || nextViewMode === 'table') {
      onViewModeChange(nextViewMode)
    }
  }

  return (
    <div
      data-view-mode-toggle-no-keys
      onKeyDownCapture={(e) => {
        e.preventDefault()
        e.stopPropagation()
      }}>
      <ToggleGroup
        type='single'
        variant='outline'
        size='lg'
        value={viewMode}
        onValueChange={handleValueChange}>
        <ToggleGroupItem value='card'>Card</ToggleGroupItem>
        <ToggleGroupItem value='table'>Table</ToggleGroupItem>
      </ToggleGroup>
    </div>
  )
}
